import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../lib/ApiProvider';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: () => ['dashboard', 'summary'] as const,
};

/** Live operational KPIs. The server decides the scope (global vs owner) from the caller's grants. */
export function useDashboardSummary() {
  const api = useApi();
  return useQuery({
    queryKey: dashboardKeys.summary(),
    queryFn: () => api.getDashboardSummary(),
  });
}
